import { render, staticRenderFns } from "./AttackEventsTable.vue?vue&type=template&id=39c7b452"
import script from "./AttackEventsTable.vue?vue&type=script&lang=js"
export * from "./AttackEventsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports